import { render, staticRenderFns } from "./templateManagement.vue?vue&type=template&id=c599ba52&scoped=true&"
import script from "./templateManagement.vue?vue&type=script&lang=js&"
export * from "./templateManagement.vue?vue&type=script&lang=js&"
import style0 from "./templateManagement.vue?vue&type=style&index=0&id=c599ba52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c599ba52",
  null
  
)

export default component.exports